import React from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { formatJpDateTime } from "../../../utils/dateUtils";
import MemberMenu from "./MemberMenu";

export default function MemberTable({
  members,
  currentPage,
  pagination,
  currentCompanyUser,
  navigate,
  onEdit,
  onDelete,
  onRestore,
  onSendRegisterMail,
}) {
  // メンバーがいない場合の表示
  if (!members || members.length === 0) {
    return (
      <Typography color="text.secondary" sx={{ mt: 4, textAlign: "center" }}>
        メンバーが登録されていません
      </Typography>
    );
  }

  return (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: 2,
        boxShadow: 1,
      }}
    >
      {/* ヘッダー */}
      <Table
        sx={{
          "& .MuiTableCell-root": {
            px: 1,
          },
        }}
      >
        <TableHead>
          <TableRow>
            {/* ヘッダー一覧 */}
            {[
              "No",
              "氏名",
              "イニシャル",
              "年齢",
              "性別",
              "最寄り駅",
              "エンジニア歴",
              "最終更新日",
              "担当者",
              "",
            ].map((header) => (
              <TableCell
                key={header}
                align="center"
                sx={{
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  backgroundColor: "#eaf3ff",
                }}
              >
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {/* メンバー一覧 */}
          {[...members].map((user, idx) => (
            <TableRow
              key={user.id}
              hover
              sx={{
                "& td": {
                  fontSize: "0.75rem",
                  whiteSpace: "nowrap",
                },
              }}
            >
              {/* No（ページ番号考慮） */}
              <TableCell align="center">
                {((pagination?.current_page ?? currentPage ?? 1) - 1) *
                  (pagination?.per_page || 10) +
                  idx +
                  1}
              </TableCell>

              {/* 氏名 */}
              <TableCell align="center">{user.full_name}</TableCell>

              {/* イニシャル */}
              <TableCell align="center">{user.name || "-"}</TableCell>

              {/* 年齢 */}
              <TableCell align="center">
                {user.age ? `${user.age}歳` : "-"}
              </TableCell>

              {/* 性別 */}
              <TableCell align="center">{user.gender || "-"}</TableCell>

              {/* 最寄り駅 */}
              <TableCell
                align="center"
                sx={{
                  maxWidth: 200,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <Box
                  component="span"
                  sx={{
                    display: "block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {user.nearest_station_line && user.nearest_station
                    ? `${user.nearest_station_line} ${user.nearest_station}`
                    : user.nearest_station_line
                      ? user.nearest_station_line
                      : user.nearest_station
                        ? user.nearest_station
                        : "-"}
                </Box>
              </TableCell>

              {/* エンジニア歴 */}
              <TableCell align="center">
                {user.work_histories_flag ? user.engineer_history : "未作成"}
              </TableCell>

              {/* 最終更新日 */}
              <TableCell align="center">
                {user?.updated_at ? formatJpDateTime(user.updated_at) : "-"}
              </TableCell>

              {/* 担当者 */}
              <TableCell align="center">{user.manager_name || "-"}</TableCell>

              {/* 操作メニュー */}
              <TableCell align="center">
                <MemberMenu
                  user={user}
                  currentCompanyUser={currentCompanyUser}
                  onDetail={() => {
                    if (user.skill_sheet_flag) {
                      navigate(`/company/members/${user.id}/skill_sheet`);
                    } else {
                      navigate(
                        `${user.id}/skill_sheet_basics/new?company_user_id=${user.id}`,
                      );
                    }
                  }}
                  onEdit={() => onEdit(user)}
                  onDelete={() => onDelete(user)}
                  onRestore={() => onRestore(user)}
                  onSendRegisterMail={() => onSendRegisterMail(user)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
